import { render, staticRenderFns } from "./SyncServerDNSDialog.vue?vue&type=template&id=3871b914&"
import script from "./SyncServerDNSDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncServerDNSDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports